import React, { useEffect, useState } from "react";
import { DatesRangeInput, MonthRangeInput } from "semantic-ui-calendar-react";
import { startOfWeek, endOfWeek, format, startOfMonth, endOfMonth } from "date-fns";

import { DateFormat } from "utilities/dist/invoice/constants";

export const DateRangeSelector = ({ placeholder, type, onChangeDateRange, value }) => {
    const [dateRange, setDateRange] = useState("");

    useEffect(() => {
        setDateRange(value);
    }, [value]);

    const handleDateRangeChange = (e, { value }) => {
        const [start] = value?.split(" - ");

        if (start) {
            const date = new Date(start);
            const startDate = startOfWeek(date);
            const endDate = endOfWeek(date);

            setDateRange(
                `${format(startDate, "dd MMM, yyyy")} - ${format(endDate, "dd MMM, yyyy")}`
            );
            onChangeDateRange([startDate, endDate]);
        } else {
            setDateRange("");
            onChangeDateRange(null);
        }
    };

    const handleMonthChange = (e, { value }) => {
        const [start] = value?.split(" - ");

        if (start) {
            const date = new Date(start);

            const startDate = startOfMonth(date);
            const endDate = endOfMonth(date);

            setDateRange(
                `${format(startDate, "dd MMM, yyyy")} - ${format(endDate, "dd MMM, yyyy")}`
            );
            onChangeDateRange([startDate, endDate]);
        } else {
            setDateRange("");
            onChangeDateRange(null);
        }
    };

    return (
        <>
            {type === "Weekly" ? (
                <DatesRangeInput
                    clearable={true}
                    animation={null}
                    maxDate={new Date()}
                    placeholder={placeholder}
                    value={dateRange}
                    dateFormat={DateFormat.toUpperCase()}
                    onChange={handleDateRangeChange}
                />
            ) : (
                <MonthRangeInput
                    clearable={true}
                    animation={null}
                    value={dateRange}
                    dateFormat={DateFormat.toUpperCase()}
                    onChange={handleMonthChange}
                />
            )}
        </>
    );
};
